import { render, staticRenderFns } from "./render-money-column-value.vue?vue&type=template&id=42701022&scoped=true"
import script from "./render-money-column-value.vue?vue&type=script&lang=js"
export * from "./render-money-column-value.vue?vue&type=script&lang=js"
import style0 from "./render-money-column-value.vue?vue&type=style&index=0&id=42701022&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42701022",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42701022')) {
      api.createRecord('42701022', component.options)
    } else {
      api.reload('42701022', component.options)
    }
    module.hot.accept("./render-money-column-value.vue?vue&type=template&id=42701022&scoped=true", function () {
      api.rerender('42701022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/render/render-money-column-value.vue"
export default component.exports